import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import BlogIndex from "./pages/BlogIndex";
import BlogPost from "./pages/BlogPost";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        {/* Archived: no nav link, kept for old inbound URLs */}
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        {/* Redirect legacy top-level pages to their new home-page anchors */}
        <Route path="/services" element={<Navigate to="/#build" replace />} />
        <Route path="/systems" element={<Navigate to="/#how" replace />} />
        <Route path="/about" element={<Navigate to="/#why" replace />} />
        <Route path="/case-studies" element={<Navigate to="/#measure" replace />} />
        <Route path="/contact" element={<Navigate to="/#contact" replace />} />
        <Route path="/junk-removal" element={<Navigate to="/#build" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
